import { Checkbox, Grid, Tooltip, Typography } from '@material-ui/core';
import { CardDestinatarioProps } from './card-destinatario-props';
import { DefaultCard } from '../components/default-card';
import { useDefaultCardStyles } from '../components/default-card/default-card-styles';
import { useStyles } from './card-destinatario-styles'
import { useSessaoAtual } from 'services/app';
import { EnumTipoPessoas } from 'model/enums/enum-tipo-pessoas';
import { LixoIcon } from 'views/components/icons';
import { toDateString } from 'utils/to-date';

export const CardDestinatario = ({
    model,
    onClick,
    onCheck,
    onClickRemove,
    isPendente,
    isSelectMode,
    selected
}: CardDestinatarioProps) => {
    const classes = useDefaultCardStyles();
    const propagandaClasses = useStyles({
        ativo: model.ativo
    });
    const { tipoUsuario } = useSessaoAtual()

    return (
        <>
            <DefaultCard
                onClick={() => {
                    if (isSelectMode) {
                        onClick(model.id);
                        return
                    }
                    onCheck(model);
                }}
            >
                <Tooltip title={model.ativo ? 'Ativo' : 'Inativo'} placement='right'>
                    <div className={propagandaClasses.status} />
                </Tooltip>
                {isSelectMode && (
                    <Checkbox
                        checked={selected}
                        onChange={(e) => {
                            e.preventDefault();
                            e.stopPropagation()
                            onClick(model.id);
                        }}
                    />
                )}
                <Grid container spacing={2} className={`${propagandaClasses.cardContent} ${propagandaClasses.gridContainer}`}>
                    <Grid item xs={6} md={3}>
                        <Typography>Cliente</Typography>
                        <Typography color={model.clienteNome ? 'textPrimary' : 'textSecondary'}><b>{model.clienteNome ?? 'Sem informações'}</b></Typography>
                    </Grid>
                    <Grid item xs={6} md={3}>
                        <Typography>Gerente</Typography>
                        <Typography>{model?.gerenteNome ?? '-'}</Typography>
                    </Grid>
                    {tipoUsuario() !== EnumTipoPessoas.Revendedor && (
                        <Grid item xs={6} md={3}>
                            <Typography>Revenda</Typography>
                            <Typography>{model.revendaNome ?? '-'}</Typography>
                        </Grid>
                    )}
                    <Grid item xs={6} md={3}>
                        <Typography>Parâmetros</Typography>
                        <Typography>{model?.parametros || '-'}</Typography>
                    </Grid>
                    {model.respostaData && (
                        <Grid item xs={6} md={3}>
                            <Typography>Resposta Data</Typography>
                            <Typography>{toDateString(model.respostaData, 'DD/MM/yyyy HH:mm')}</Typography>
                        </Grid>
                    )}
                    {model.respostaConteudo && (
                        <Grid item xs={6} md={3}>
                            <Typography>Resposta Conteúdo</Typography>
                            <Typography><b>{model.respostaConteudo}</b></Typography>
                        </Grid>
                    )}
                </Grid>
                {isPendente && (
                    <Tooltip arrow title="Remover Destinatário">
                        <div className={classes.cardRightButton} style={{ margin: '0px 0px 0px 10px' }} onClick={(e) => {
                            e.preventDefault();
                            e.stopPropagation()
                            onClickRemove(model.id);
                        }}>
                            <LixoIcon
                                tipo="BUTTON"
                            />
                        </div>
                    </Tooltip>
                )}
            </DefaultCard>
        </>
    );
};